import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './checkbox.module.scss';
/** @deprecated Use `Checkbox` instead. */ export const Checkbox = ({ className, state = 'default', ...props })=>/*#__PURE__*/ _jsx("input", {
        type: "checkbox",
        ...props,
        className: classNames('checkbox', styles.checkbox, styles[state], className)
    });

//# sourceMappingURL=checkbox.js.map